module.exports = __webpack_public_path__ + "img/1049_help_title_69d047858.png";